import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class floorEdit_template extends vnTemplate{

    public destinationFilter: filterDropdown_template;
    public adSetupFilter: filterDropdown_template;
    public deviceTypeFilter: filterDropdown_template;
    public zoneFilter: filterDropdown_template;
    public geoFilter: filterDropdown_template;
    public mediaTypeFilter: filterDropdown_template;
    public dimensionsFilter: filterDropdown_template;
    public bidderTypeFilter: filterDropdown_template;
    public bidderFilter: filterDropdown_template;

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        return `
            <div class="form-header">
                <!-- ko ifnot: id -->
                <h3 class="form-title icon i-bid-floow">Add Floor</h3>
                <!-- /ko -->

                <!-- ko if: id -->
                <h3 class="form-title icon i-bid-floor">Edit Floor</h3>
                <!-- /ko -->

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>

            <div class="form-body">

                <div class="form-group row">
                    <label for="note" class="form-label">Note</label>
                    <div>
                        <input style="width:100%" id="note" data-bind="value: note" type="text" class="input-text">
                    </div>
                </div>
                <!-- ko if: idBrand -->
                    <div class="form-group row">
                        <label for="brandName" class="form-label">Brand</label>
                        <div>
                            <input style="width:100%" id="brandName" data-bind="value: brandName" type="text" class="input-text" disabled>
                        </div>
                    </div>
                <!-- /ko -->
                <div class="form-group row">
                    <label class="form-label">Destination</label>
                    ${this.destinationFilter.getHtmlBuild()}
                </div>
                <!-- ko if: idBrand -->
                <div class="form-group row">
                    <label class="form-label">Ad Setup</label>
                    ${this.adSetupFilter.getHtmlBuild()}
                </div>
                <!-- /ko -->
                <div class="form-group row">
                    <label class="form-label">Device Type</label>
                    ${this.deviceTypeFilter.getHtmlBuild()}
                </div>
                <div class="form-group row">
                    <label class="form-label">Geo</label>
                    ${this.geoFilter.getHtmlBuild()}
                </div>
                <div class="form-group row">
                    <label class="form-label">Zone</label>
                    ${this.zoneFilter.getHtmlBuild()}
                </div>
                <div class="form-group row">
                        <label for="parentZoneName" class="form-label">Parent Zone</label>
                        <div>
                            <input style="width:100%" id="parentZoneName" data-bind="value: parentZoneName" type="text" class="input-text" disabled>
                        </div>
                    </div>
                <div class="form-group row">
                    <label class="form-label">Media Type</label>
                    ${this.mediaTypeFilter.getHtmlBuild()}
                </div>
                <div class="form-group row">
                    <label class="form-label">Dimensions</label>
                    ${this.dimensionsFilter.getHtmlBuild()}
                </div>
                <div class="form-group row">
                    <label class="form-label">Bidder Type</label>
                    ${this.bidderTypeFilter.getHtmlBuild()}
                </div>
                <!-- ko if: showBidder -->
                <div class="form-group row">
                    <label class="form-label">Bidder</label>
                    ${this.bidderFilter.getHtmlBuild()}
                </div>
                <!-- /ko -->
                <div class="form-group row">
                    <label for="value" class="form-label">Value($)</label>
                    <div>
                        <input style="width:100%" id="value" data-bind="value: value" type="number" min="0" step="0.01" class="input-text num">
                    </div>
                </div>
            </div>   
          
            <div class="form-footer">
                <button data-bind="event: { click: onClickCancel }" class="btn-action icon i-cancel-thin" type="button"><span>Cancel</span></button>
                <button data-bind="event: { click: onClickSave }" class="btn-action icon i-save-thin" type="button"><span>Save</span></button>  
            </div>
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial():void{

        this.destinationFilter = new filterDropdown_template('destinationFilter', this.getTemplateViewModel(), this.caller);
        this.adSetupFilter     = new filterDropdown_template('adSetupFilter', this.getTemplateViewModel(), this.caller);
        this.deviceTypeFilter  = new filterDropdown_template('deviceTypeFilter', this.getTemplateViewModel(), this.caller);
        this.geoFilter         = new filterDropdown_template('geoFilter', this.getTemplateViewModel(), this.caller);
        this.zoneFilter        = new filterDropdown_template('zoneFilter', this.getTemplateViewModel(), this.caller);
        this.mediaTypeFilter   = new filterDropdown_template('mediaTypeFilter', this.getTemplateViewModel(), this.caller);
        this.dimensionsFilter  = new filterDropdown_template('dimensionsFilter', this.getTemplateViewModel(), this.caller);
        this.bidderTypeFilter  = new filterDropdown_template('bidderTypeFilter', this.getTemplateViewModel(), this.caller);
        this.bidderFilter      = new filterDropdown_template('bidderFilter', this.getTemplateViewModel(), this.caller);
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'floorEdit_template';
    }

    /**
     * @inheritDoc
     */
    protected getMainElementClasses(): Array<string>{

        return ['w-form', 'margin-top'];
    }

    /**
     * @inheritDoc
     */
    protected buildViewModel(): any{

        let self      = this;
        let viewModel = {
            id: ko.observable(0),
            note: ko.observable(''),
            idBrand: ko.observable(0),
            brandName: ko.observable(''),
            parentZoneName: ko.observable('None'),
            value: ko.observable(0),
            showBidder: ko.observable(false),
            mobileAdSetups: ko.observableArray([]),
            desktopAdSetups: ko.observableArray([]),
            adSetups: ko.observableArray([]),
            deviceTypes: ko.observableArray([]),
            bidderTypes: ko.observableArray([]),
            amazonBidders: ko.observableArray([]),
            prebidBidders: ko.observableArray([]),
            bidders: ko.observableArray([]), 
            zones: ko.observableArray([]),
            onClickSave: function(data, event){ self.onClickSave(); },
            onClickCancel: function(data, event){ self.onClickCancel(); }
        };

        return viewModel;
    }

    /**
     * @inheritDoc
     */
    public getViewModelForRequest(): Object{

        let selectedZoneOption = this.zoneFilter.getTemplateViewModel().selectedOption();
        let zones              = this.getTemplateViewModel().zones();
        let slectedZone        = zones.find(function(zone){

            return zone.id === selectedZoneOption;
        })

        return {
            id: this.getTemplateViewModel().id(),
            note: this.getTemplateViewModel().note(),
            idBrand: this.getTemplateViewModel().idBrand(),
            destination: this.destinationFilter.getTemplateViewModel().selectedOption(),
            adSetup: this.adSetupFilter.getTemplateViewModel().selectedOption(),
            deviceType: this.deviceTypeFilter.getTemplateViewModel().selectedOption(),
            geo: this.geoFilter.getTemplateViewModel().selectedOption(),
            zone: slectedZone.name || null,
            parentZone: slectedZone.nameParent || null,
            mediaType: this.mediaTypeFilter.getTemplateViewModel().selectedOption(),
            dimensions: this.dimensionsFilter.getTemplateViewModel().selectedOption(),
            bidderType: this.bidderTypeFilter.getTemplateViewModel().selectedOption(),
            bidder: this.bidderFilter.getTemplateViewModel().selectedOption(),
            value: this.getTemplateViewModel().value(),
        };
    }

    //
    // Sets form data.
    public setFormData(data): void{

        this.getTemplateViewModel().id(data.id);
        this.getTemplateViewModel().value(data.value);
        this.getTemplateViewModel().note(data.note);

        if(data.destination){

            this.destinationFilter.getTemplateViewModel().selectedOption(data.destination.id);
        }

        if(data.adSetup){

            this.adSetupFilter.getTemplateViewModel().selectedOption(data.adSetup.id);
        }

        if(data.deviceType){

            this.deviceTypeFilter.getTemplateViewModel().selectedOption(data.deviceType.id);
        }

        if(data.geo){

            this.geoFilter.getTemplateViewModel().selectedOption(data.geo.id);
        }

        if(data.zoneName){

            this.zoneFilter.getTemplateViewModel().selectedOption(data.zoneName);
            this.getTemplateViewModel().parentZoneName(data.parentZoneName || 'None');
        }

        if(data.mediaType){

            this.mediaTypeFilter.getTemplateViewModel().selectedOption(data.mediaType.id);
        }

        if(data.dimensions){

            this.dimensionsFilter.getTemplateViewModel().selectedOption(data.dimensions.id);
        }

        if(data.bidderType){

            this.bidderTypeFilter.getTemplateViewModel().selectedOption(data.bidderType.id);
        }

        if(data.bidder){

            this.bidderFilter.getTemplateViewModel().selectedOption(data.bidder.id);
        }

        let selectedDestinationOption = this.destinationFilter.getTemplateViewModel().selectedOption();

        if(2 === selectedDestinationOption){

            this.getTemplateViewModel().showBidder(true);
        }
    }

    //
    // Handles clicking save button event.
    protected onClickSave(): void{

        this.caller.save();
    }

    //
    // Handles clicking save button event.
    protected onClickSaveFromModal(): void{

        this.caller.save();
    }

    //
    // Handles clicking cancel button event.
    protected onClickCancel(): void{

        this.caller.cancel();
    }
}
